<div
  [proffeoSpinner]="files() === undefined"
  proffeoSpinnerSize="xs"
  class="min-h-48 w-full"
>
  @if (files(); as fileList) {
    <div class="flex overflow-x-auto gap-2.5 pb-2">
      @for (file of fileList; track file.id) {
        <proffeo-mini-file-item
          (preview)="onPreviewFile($event)"
          (delete)="onDeleteFile($event)"
          (download)="onDownloadFile($event)"
          (setAsAvatar)="onSetAsAvatar($event)"
          [file]="file"
          [canSetAsAvatar]="canSetAsAvatar() && file.isImage()"
          [isAvatar]="avatarFileId() === file.id"
          class="w-44 shrink-0"
        />
      }
    </div>
  }
</div>
